import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiAddGuardianModule } from '../lib/shared-ui-add-guardian.module'
import { AddGuardianDocsComponent } from './add-guardian-docs/add-guardian-docs.component'
import { AddGuardianExampleComponent } from './add-guardian-docs/add-guardian-example.component'

@NgModule({
  declarations: [
    AddGuardianDocsComponent,
    AddGuardianExampleComponent
  ],
  exports: [AddGuardianDocsComponent],
  imports: [
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFePageModule,
    SeFeHeaderModule,
    SharedUiAddGuardianModule,
  ]
})
export class SharedUiAddGuardianDocsModule { }
